<template>
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.60078 0.400024C2.10919 0.418481 1.6449 0.630808 1.3094 0.99059C0.973903 1.35037 0.794489 1.82834 0.810377 2.32002L0.800777 17.68C0.784889 18.1717 0.964303 18.6497 1.2998 19.0095C1.6353 19.3692 2.09959 19.5816 2.59118 19.6H13.4008C13.8934 19.5822 14.359 19.3704 14.6962 19.0107C15.0333 18.6511 15.2147 18.1728 15.2008 17.68V6.16002L9.80078 0.400024H2.60078ZM8.90078 7.12002V1.84002L13.8508 7.12002H8.90078Z"
      fill="#365DF0"
    />
  </svg>
</template>

<script>
export default {
  name: 'b-icon-file',
  components: {},
  computed: {},
  props: {},
}
</script>

<style scoped lang="scss"></style>

<docs>
	IconFile

	```js
	<b-icon-file />
	```
</docs>